/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { Signature as S2 } from "parog-web/components/fui-calendar";
import { datetimeFormat } from "parog-web/helpers/datepicker-format";

interface S {
  Args: {
    labelName?: string;
    propertyName?: string;
    isMandatory?: boolean;
    onChange: S2["Args"]["onFocusOut"];
  } & Pick<S2["Args"], "selected" | "disabled" | "isReadOnly">;
}

export default class DateTimePickerComponent extends Component<S> {
  formatter = {
    datetime: datetimeFormat
  };
}
